import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

import { deleteTicketType, getTicketTypesByEventIdAdmin } from "../../api/ticket-types";
import DashboardLayout from "./components/Layout";

const TicketTypePage = () => {
  const { eventId: id } = useParams();
  const [eventData, setEventData] = useState(null);

  const fetchData = async (id) => {
    const response = await getTicketTypesByEventIdAdmin(id);
    setEventData(response?.data?.data);
  };

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onDelete = async (eventId, ticketTypeId) => {
    const confirmed = window.confirm("Bu bilet növünü silmək istədiyinizə əminsiniz?");
    if (confirmed) {
      try {
        await deleteTicketType(eventId, ticketTypeId);
        fetchData(eventId); // Silmədən sonra siyahını yenilə
      } catch (error) {
        console.error("Bilet növü silinərkən xəta baş verdi:", error);
        alert("Silinmə zamanı xəta baş verdi.");
      }
    }
  };

  return (
    <DashboardLayout id={id}>
      <div className="mt-2">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">🎟️ Bilet Növləri Siyahısı</h2>
        <Link
          to={`/dashboard/${id}/ticket-types/new`}
          className="bg-gray-800 text-white px-5 py-2 rounded-md hover:bg-gray-700 transition"
        >
          Yeni Bilet Növü
        </Link>
      </div>


        {/* Table */}
        <div className="overflow-auto rounded-xl shadow">
          <table className="min-w-full bg-white">
            <thead>
              <tr className="bg-gray-200 text-left text-sm font-semibold text-gray-700">
                <th className="p-4">Adı </th>
                <th className="p-4">Qiymət</th>
                <th className="p-4">Əvvəlki qiyməti</th>
                <th className="p-4">Status</th>
                <th className="p-4">Limit</th>
                <th className="p-4">Əməliyyatlar</th>
              </tr>
            </thead>
            <tbody>
              {eventData?.map((item) => (
                <tr key={item._id} className="border-t text-sm hover:bg-gray-50">
                  <td className="p-4">{item?.name?.az}</td>
                  <td className="p-4">{item?.price} ₼</td>
                  <td className="p-4">{item?.salePrice ? `${item?.salePrice} ₼` : '-'}</td>
                  <td className="p-4">
                    {item?.isActive ? "aktiv" : "deaktiv"}
                  </td>
                  <td className="p-4">
                    {item?.count || 'yoxdur'}
                  </td>
                  <td className="p-4 space-x-2">
                    <Link
                      to={`/dashboard/${id}/ticket-types/${item?._id}`}
                      className="text-yellow-600 hover:underline">
                      Düzəlt
                    </Link>
                    <button
                      onClick={() => onDelete(id, item._id)}
                      className="text-red-600 hover:underline"
                    >
                      Sil
                    </button>
                  </td>
                </tr>
              ))}
              {eventData?.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center p-4 text-gray-500">
                    Heç bir nəticə tapılmadı.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default TicketTypePage;
